<template>
  <div v-if="DynamicPageHtml">
    <div class="scoped-dynamic-content" v-html="DynamicPageHtml"></div>
  </div>
</template>
<script>
import { mapState, mapGetters } from "vuex";

export default {
  name: "Home",
  computed: {
    ...mapState({
      company: state => state.company.company
    }),
    ...mapGetters("app", {
        currentLanguage: "getCurrentLanguage",
    }),
    DynamicPageHtml(){
      let fullHtml = '';

      if (this.company.festival_home_page) {
        const rawCss = this.company.festival_home_page[this.currentLanguage].css;
        const htmlContent = this.company.festival_home_page[this.currentLanguage].html;

        // Prefix all selectors in the CSS with `.scoped-dynamic-content`
        const scopedCss = rawCss.replace(/(^|\})\s*([^{]+)/g, (match, p1, selector) => {
          // skip @media or @keyframes etc
          if (selector.trim().startsWith('@')) return match;
          // add scope prefix to selectors
          const newSelector = selector
            .split(',')
            .map(sel => `.scoped-dynamic-content ${sel.trim()}`)
            .join(', ');
          return `${p1} ${newSelector}`;
        });

        fullHtml = `
          <style>
            ${scopedCss}
          </style>
          ${htmlContent}
        `;
      }

      return fullHtml;
    }
  },
  methods: {
    
  },
};
</script>

<style>
.scoped-dynamic-content {
  /* max-width: 800px; */
  margin-top: 0px;
  margin-right: auto;
  margin-bottom: 0px;
  margin-left: auto;
  padding-top: 20px;
  padding-right: 20px;
  padding-bottom: 20px;
  padding-left: 20px;
  line-height: 1.5;
  box-sizing: border-box;
  font-family: Arial, sans-serif;
}

.scoped-dynamic-content .hero-section {
  width: 100vw;
  max-width: 100vw;
  position: relative;
  left: 50%;
  right: 50%;
  margin-left: -50vw;
  margin-right: -50vw;
}
</style>